import { useState } from "react";
import { Copy, Check } from "lucide-react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { tr } from "../../i18n";
const CopyText = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <span className="text-truncate">
        <b>{text}</b>
      </span>

      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{copied ? tr("shared:copied") : tr("shared:copy")}</Tooltip>}
      >
        <button
          onClick={handleCopy}
          className="btn btn-link p-0 text-secondary"
          aria-label={tr("shared:copy_text")}
        >
          {copied ? (
            <Check size={16} className="text-success" />
          ) : (
            <Copy size={16} />
          )}
        </button>
      </OverlayTrigger>
    </div>
  );
};

export default CopyText;
